import React, { createContext, useContext } from 'react';

import type { TextEntity } from 'views/App/Portal/Policy/DraftManuals/utils/textEntityProcessor';

export const ContentEditorTextEntitiesContext = createContext<TextEntity[] | undefined>(undefined);

export function useContentEditorTextEntities(): TextEntity[] | undefined {
  return useContext(ContentEditorTextEntitiesContext);
}

type ContentEditorTextEntitiesProviderProps = {
  children: React.ReactNode;
  textEntities?: TextEntity[];
};

export function ContentEditorTextEntitiesProvider({ children, textEntities }: ContentEditorTextEntitiesProviderProps) {
  return (
    <ContentEditorTextEntitiesContext.Provider value={textEntities}>{children}</ContentEditorTextEntitiesContext.Provider>
  );
}
